/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import { Packet as IOPacket } from 'socket.io-parser';

import PacketMessage from './packets/packetmessage';

import MessageCompressor from './../../messagescompressor';

export interface IPacketParserOptions {
	flags?: Record<string, unknown>;

	rooms?: string[];

	except?: string[];
}

export type Packet = IOPacket;

export default class PacketParser {
	public encode(
		type: number,
		data: unknown[],
		id?: number,
		nsp: string = '/',
		options: IPacketParserOptions = {}
	): Buffer {
		if ( data.length > 2 ) {
			throw new Error( 'PacketParser supports only 2 elements in data' );
		}

		const packet: Packet = {
			type,
			data,
			id,
			nsp
		};

		return MessageCompressor.encode( PacketMessage.create( packet, options ) );
	}

	public decode( buffer: Buffer ): { packet: Packet; options: IPacketParserOptions; } {
		const packetMessage: PacketMessage = MessageCompressor.decode( buffer as Buffer, PacketMessage ) as PacketMessage;

		const packet: Packet = {
			id: packetMessage.id,
			type: packetMessage.type,
			data: packetMessage.packetData,
			nsp: packetMessage.nsp
		};

		const options: IPacketParserOptions = {
			flags: packetMessage.options.flags,
			rooms: packetMessage.options.rooms,
			except: packetMessage.options.except
		};

		return { packet, options };
	}
}
